import React, { useEffect } from 'react';
import {
  Box, Typography, Paper, Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import InstallGuide from 'components/account/InstallGuide';
import {
  useNavigate,
  useLocation,
  Link,
} from 'react-router-dom';
import { SignIn } from 'labox-ws-commons';
import useGlobal from 'global-state/store';
import {
  getAuth, GoogleAuthProvider, signInWithPopup, signInWithEmailAndPassword,
  createUserWithEmailAndPassword, sendEmailVerification,
} from 'firebase/auth';
import { getAnalytics, logEvent } from 'firebase/analytics';
import LaboxWS from 'icons/LaboxWS';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { getApp } from 'firebase/app';
import { useAuth } from 'firebaseHooks/AuthContext';

export default function SignInPage() {
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [, globalActions] = useGlobal();
  const location = useLocation();
  const app = getApp();
  const auth = getAuth(app);
  const analytics = getAnalytics();
  const provider = new GoogleAuthProvider();

  const ourSignInWithPopup = () => signInWithPopup(auth, provider);

  useEffect(() => {
    if (currentUser) {
      navigate('/', { replace: true });
    }
  }, [navigate, currentUser]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        mt: 2,
        mb: 15,
      }}
    >
      <SignIn
        t={t}
        globalActions={globalActions}
        navigate={navigate}
        location={location}
        Link={Link}
        auth={auth}
        analytics={analytics}
        gtcuCookieName="agreed-to-general-terms-labox-inventory"
        ourSignInWithPopup={ourSignInWithPopup}
        signInWithEmailAndPassword={signInWithEmailAndPassword}
        createUserWithEmailAndPassword={createUserWithEmailAndPassword}
        logEvent={logEvent}
        sendEmailVerification={sendEmailVerification}
        LaboxWSIcon={LaboxWS}
        signinCallback={() => globalActions.setUserStatus('initial')}
      />
      <Paper
        sx={{
          flexGrow: 1,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
        }}
      >
        <Typography variant="h6" component="div">
          {t('onboarding.start_button_label')}
        </Typography>
        <Button
          size="large"
          variant="contained"
          onClick={() => { navigate('/contact'); }}
          endIcon={<ArrowForwardIosIcon />}
        >
          {t('user_card.contact_us')}
        </Button>
      </Paper>
      {/* <Typography variant="h5" component="div" sx={{ mt: 3 }}>
        {t('welcome.welcome_title')}
      </Typography>
      <Paper elevation={0} sx={{ p: 3, mb: 5 }}>
        <Typography component="p" sx={{ textAlign: 'left' }}>
          {t('welcome.welcome_text', { joinArrays: '' })}
        </Typography>
      </Paper> */}
      <InstallGuide />
    </Box>
  );
}
